import React from 'react';

export default () => {
    const NUM_ITEMS = 29;
    const items = [];
    for(let i = 1; i <= NUM_ITEMS; i++) {
        items.push(
            <li className="menu-skeleton-item" key={i}></li>
        )
    }
    return (
        <ul className="menu-skeleton">
            {items}
        </ul>
    )
}
